import { MutationTree } from 'vuex';
import { FromAddressListState, FromAddressList } from './types';
import * as types from './mutation-types';
import { ErrorDetail } from '../../types';
import { fromAddressList } from './index';

// エラーをクリアする
const resetErrors = (state: FromAddressListState): void => {
    const createState = state.create;
    createState.error = false;
    createState.errorTitle = undefined;
    createState.errorDetails = undefined;
    createState.isCreated = false;

    const showState = state.show;
    showState.error = false;
    showState.errorCode = undefined;
    showState.errorMsg = undefined;
};

export const mutations: MutationTree<FromAddressListState> = {
    // 接続元IPアドレスリスト登録系
    [types.CREATE_START](state) {
        const createState = state.create;
        createState.error = false;
        createState.errorTitle = undefined;
        createState.errorDetails = undefined;
        createState.isProcessing = true;
    },

    [types.CREATE_SUCCESS](state) {
        const createState = state.create;
        createState.isProcessing = false;
        createState.isCreated = true;
    },

    [types.CREATE_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const createState = state.create;
        createState.errorTitle = payload.errorTitle;
        createState.errorDetails = payload.errorDetails;
        createState.error = true;
        createState.isProcessing = false;
    },

    // 接続元IPアドレスリスト取得系
    [types.SHOW_START](state) {
        resetErrors(state);
        const showState = state.show;
        showState.error = false;
        showState.errorCode = undefined;
        showState.errorMsg = undefined;
        showState.isProcessing = true;
        showState.isFetchSuccess = false;
    },

    [types.SHOW_SUCCESS](state, payload) {
        const showState = state.show;
        state.fromAddressLists = payload;
        showState.isProcessing = false;
        showState.isFetchSuccess = true;
    },

    [types.SHOW_FAILURE](state, payload: { code: string; message: string }) {
        const showState = state.show;
        showState.errorCode = payload.code;
        showState.errorMsg = payload.message;
        showState.error = true;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const createState = state.create;
        createState.isProcessing = false;
        createState.isCreated = false;

        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;
    },

    [types.CLEAR_ALL](state) {
        resetErrors(state);
        state.fromAddressLists = undefined;
    },
};
